// Factory for the StekzRenderer bpmn-js module.
// Returns a module descriptor that registers StekzRenderer with the given config.
import StekzRenderer from "./stekz-renderer";
import type { StekzRendererConfig } from "./stekz-renderer";

/**
 * Creates a bpmn-js module that registers StekzRenderer for all BPMN diagrams.
 */
export default function createStekzRendererModule(hideLaneNames: boolean) {
    return {
        __init__: ["stekzRenderer"],
        stekzRenderer: ["type", StekzRenderer],
        stekzRendererConfig: [
            "value",
            { hideLaneNames } satisfies StekzRendererConfig,
        ],
    };
}
